import { Typography, Button, Grid, Tooltip, IconButton } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';

function PageHeader({ title, button_text, showCreateEditForm, createPermission, advFilter, setFilterDrawer }) {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item className='pageTitle'>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
      </Grid>
      <Grid item>
        {advFilter && <Tooltip title="Filter">
          <IconButton style={{ color: 'blue', marginRight: '15px' }} onClick={() => { setFilterDrawer() }}>
            <FilterAltIcon></FilterAltIcon>
          </IconButton>
        </Tooltip>}
        {createPermission ? (

          <Button
            sx={{ mt: { xs: 2, md: 0 }, mr: { md: 2 } }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            onClick={showCreateEditForm}
          >
            {button_text}
          </Button>
        ) : null}

      </Grid>
    </Grid>
  );
}

PageHeader.defaultProps = {
  title: '',
  button_text: '',
  showCreateEditForm: () => { },
  createPermission: false,
  advFilter: false,
  setFilterDrawer: () => { },
}

export default PageHeader;
